<template>
  <div class="massaction-compliance-modal">
    <!-- start:: Modal Header -->
    <div class="modal-header-group">
      <span class="top-header-title">{{
        compliance.type == "questionnaire" ? "Questionnaire" : "Agreement"
      }}</span>
      <svg
        class="close-btn"
        @click="$bvModal.hide('compliance')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>
    <!-- end:: Modal Header -->

    <p class="modal-sub-header">
      <template v-if="compliance.form_metadata.status">
        <template v-if="compliance.form_metadata.status == 'success'">
          {{ $t("signInOut.complianceCompleted") }}
        </template>
        <template v-else-if="compliance.form_metadata.status == 'failed'">
          {{ $tc("signInOut.complianceFailed", 1) }}
        </template>
      </template>
      <template v-else>{{ $tc("signInOut.complianceFailed", 2) }}</template>
    </p>
    <p class="action-by-style" v-if="compliance.form_metadata.isExpected">
      {{ getDate(compliance.updated_at) }}<b> • </b> By
      {{ compliance.form_metadata.actionByRole
      }}<strong class="strong-txt">
        ({{ compliance.form_metadata.actionByName }})</strong
      >
    </p>
    <p class="compliance-name">
      {{ compliance.name.charAt(0).toUpperCase() + compliance.name.slice(1) }}
    </p>
    <p class="header-note">
      {{ $tc("signInOut.complianceHeader", 1) }}
    </p>
    <ul>
      <li
        v-for="(question, index) in compliance.form_metadata.questions"
        :key="question.body"
      >
        <template>
          <p
            class="question-body mb-4"
            style="line-height: 28px; word-wrap: break-word"
          >
            <template v-if="compliance.type == 'questionnaire'">{{
              `${index + 1} - `
            }}</template>
            <template v-if="!readMore[index]">
              {{ question.body.substring(0, 150) }}
            </template>

            <template v-if="readMore[index]">
              {{ question.body }}
            </template>

            <a
              class="read_more"
              v-if="!readMore[index] && question.body.length >= 200"
              @click="showMore(index)"
              >{{ $t('common.readMore') }}</a
            >
            <a class="read_more" v-if="readMore[index]" @click="showLess(index)"
            >{{ $t('common.readLess') }}</a
            >
          </p>
          <b-form-group
            class="question-body input-wrapper custom-radios custom-activeRadio"
          >
            <b-form-radio-group
              class="align-column"
              v-model="tempAnswers[index]"
              @input="updateFinalAnswerModel($event, index)"
            >
              <b-form-radio
                class="first-radiocheck mb-3"
                :value="question.answers[0].text"
                :text="question.answers[0].text"
              >
                {{ question.answers[0].text }}
              </b-form-radio>

              <b-form-radio
                class="first-radiocheck"
                :value="question.answers[1].text"
                :text="question.answers[1].text"
              >
                {{ question.answers[1].text }}
              </b-form-radio>
            </b-form-radio-group>
            <hr class="questions-divider" />
          </b-form-group>
        </template>
      </li>
    </ul>
    <p class="fillin-note">
      <b>{{ $t("common.notes.note") }}:</b> {{ $t("signInOut.mandatoryNotes") }}
    </p>

    <span
      class="compliance-note-label"
      v-if="compliance.form_metadata.notes.length && !showNotesLabel"
      >{{ $tc("signInOut.complianceNote", 1) }}</span
    >

    <b-form-textarea
      :class="{
        'remove-padding':
          compliance.form_metadata.notes.length && showNotesLabel,
        'top-padding': compliance.form_metadata.notes.length && !showNotesLabel,
      }"
      v-model="compliance.form_metadata.notes"
      class="note-textarea"
      :placeholder="$tc('signInOut.complianceNote', 1)"
      type="text"
      rows="4"
      no-resize
      maxlength="255"
    ></b-form-textarea>

    <button
      :disabled="
        (!modelIsTouched && compliance.form_metadata.isDirty) ||
        $v.compliance.form_metadata.questions.$invalid
      "
      class="compliance-fillin-btn"
      @click="onSubmit"
    >
      {{ compliance.form_metadata.isDirty ? updateBtnValue : fillInBtnValue }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { toUpper } from "lodash";

export default {
  data() {
    return {
      readMore: {},
      questions: [],
      compliance: {},
      notes: "",
      showNotesLabel: true,
      modelIsTouched: false,
      tempAnswers: [],
    };
  },
  validations: {
    compliance: {
      form_metadata: {
        questions: {
          $each: {
            finalAnswers: {
              validateFinalAnswer: function (answer) {
                if (
                  answer.desired === true ||
                  (answer.desired === false &&
                    this.compliance.form_metadata.notes.length >= 20)
                )
                  return true;
                return false;
              },
            },
          },
        },
      },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    fillInBtnValue(){
      return toUpper(this.$t('signInOut.fillIn'))
    },
    updateBtnValue(){
      return toUpper(this.$t('common.update'))
    }
  },
  watch: {
    "compliance.form_metadata.notes"() {
      let textArea = document.querySelector(".note-textarea");
      this.showNotesLabel = textArea?.scrollHeight > textArea?.clientHeight + 3;
    },
    "compliance.form_metadata": {
      handler(_, newValue) {
        if (newValue && Object.keys(newValue)?.length) {
          this.modelIsTouched = true;
        } else {
          this.modelIsTouched = false;
        }
      },
      deep: true,
    },
  },
  beforeMount() {
    this.compliance = JSON.parse(JSON.stringify(this.getModalInfo));
    // this.compliance.form_metadata.questions.forEach(console.log)
    this.tempAnswers = this.compliance.form_metadata?.questions?.map(
      (question) => {
        return question.finalAnswers?.text ?? "";
      }
    );
  },
  methods: {
    updateFinalAnswerModel(answerText, questionIndex) {
      const answeredQuestionObject = this.compliance.form_metadata.questions[
        questionIndex
      ].answers.find((question) => question.text == answerText);

      this.$v.compliance.form_metadata.questions.$each.$iter[
        questionIndex
      ].finalAnswers.$model = answeredQuestionObject;
    },
    onSubmit() {
      this.compliance.form_metadata.isDirty = true;
      this.compliance.form_metadata.status = "success";
      if (this.compliance.allAction) {
        this.$emit(
          "massActionComplianceSubmit",
          this.compliance.form_metadata,
          this.compliance.id
        );
      } else {
        this.$emit(
          "complainceSubmit",
          this.compliance.form_metadata,
          this.compliance.userId,
          this.compliance.id
        );
      }

      this.$bvModal.hide("compliance");
    },
    getDate(date) {
      return moment
        .utc(date)
        .tz(moment.tz.guess())
        .format("DD/MM/YYYY - h:mm A");
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
  },
};
</script>

<style lang="scss">
div#compliance {
  .first-radiocheck.mb-3.custom-control.custom-control-inline.custom-radio {
    label.custom-control-label {
      padding-top: 5px;
      padding-inline-start: 16px;
    }
  }
}
.massaction-compliance-modal {
  //Modal header
  .modal-header-group {
    width: 100%;
    text-align: center;
    margin: 15px auto 38px auto;
    span.top-header-title {
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      text-align: center;
      color: #000000;
    }
  }

  .top-header-title {
    font-weight: 700;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.25px;
  }

  // .close-modal-btn {
  //   position: relative;
  //   bottom: 5px;
  //   inset-inline-start: 125px;
  // }

  .modal-sub-header {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #666666;
    margin-bottom: 30px;
  }

  .compliance-name {
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: start;
    color: #939393;
  }

  .header-note {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.25px;
    text-align: start;
    color: #606060;
    margin: 30px 0;
    opacity: 0.8 !important;
  }
  .question-body {
    font-size: 16px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
    color: #606060;
    opacity: 0.8 !important;
  }
  .fillin-note {
    font-size: 14px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0.25px;
    text-align: start;
    color: #939393;
    opacity: 0.8 !important;
    margin: -18px 15px 20px 15px;
  }
  .note-textarea {
    background-color: #f2f2f2 !important;
    border-color: #f2f2f2 !important;
    width: 415px;
    height: 100px;
    border: none;
    resize: none;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 22px;
    letter-spacing: 0.25px;
    color: rgba(0, 0, 0, 0.87) !important;
    opacity: 0.8 !important;
    border-radius: 4px;
    padding-inline-start: 20px !important;
  }
  .remove-padding {
    padding-top: -10px !important;
  }
  .top-padding {
    padding-top: 26px !important;
  }
  .note-textarea::placeholder {
    position: relative;
    top: 4px;
  }
  .compliance-fillin-btn {
    height: 44px;
    width: 415px;
    inset-inline-start: 0px;
    top: 0px;
    border-radius: 22px;
    background-color: #103f5e;
    border: 0;
    border-radius: 22px;

    font-size: 16px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: center;
    color: #ffffff;
    margin-top: 30px;
  }
  .align-column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 70px;
    margin-top: 15px;
  }

  .custom-control-label::before {
    width: 20px;
    height: 20px;
    background: #c7c7c7 !important;
    //margin-top: -7px;
    border: 0 !important;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #103f5e !important;
    z-index: 1;
    border: 4px solid #c7c7c7 !important;
  }
  .custom-activeRadio
    .custom-radio
    .custom-control-input:checked
    ~ .custom-control-label
    span {
    color: #103f5e;
  }
  .custom-radios.custom-activeRadio {
    margin-top: -10px;
  }
  .custom-activeRadio
    .custom-radio
    .custom-control-input:checked
    ~ .custom-control-label::after {
    display: none;
  }
  .question-divider {
    margin: 30px 0;
    color: #606060;
  }
  .compliance-note-label {
    position: absolute;
    margin-inline-start: 20px;
    margin-top: 10px;
    z-index: 2;
    color: #103f5e;
    font-size: 12px;
    opacity: 0.8;

    font-weight: 700;

    line-height: 17px;
    letter-spacing: 0.25px;
    opacity: 0.8;
  }
  .questions-divider {
    margin: 25px 0;
  }
  .compliance-fillin-btn:disabled {
    background-color: #96abb8;
  }
  .action-by-style {
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    color: #939393;
    margin-inline-start: 2px;
    margin-bottom: 25px;

    .strong-txt {
      color: #939393;
    }
  }
  .col-form-label {
    max-width: 377px !important;
    white-space: normal !important;
  }

  .read_more {
    width: 69px;
    height: 17px;
    inset-inline-start: 721px;
    top: 503px;

    font-weight: 700;
    font-size: 14px;
    line-height: 23.5px;
    text-decoration-line: underline !important;
    color: #2680eb;
  }
}
</style>
